import { httpRequest } from './httpRequest';

export const httpGetAsync = (
  url: string,
  callback: (response: string) => void,
  onError?: () => void,
  withCredentials?: boolean
): void => {
  httpRequest({ url, method: 'GET', callback, onError, withCredentials });
};
